import React from 'react';
import { BreadcrumbsConfigContext } from './breadcrumbsConfigContext';

const context = React.createContext<BreadcrumbsConfigContext>({ breadcrumbsConfig: {}, setBreadcrumbsConfig: () => {} });

export const BreadcrumbsConfigContextProvider = context.Provider;
export default context;
